<style>
@import '../../assets/css/report.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.created_at"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_username')}}</template>
                        <b-form-input v-model="ajaxSearch.login"></b-form-input>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_type')}}</template>
                        <b-form-select v-model="ajaxSearch.type">
                            <option value="email">Email</option>
                            <option value="sms">SMS</option>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" @click="initialize()">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </b-card>
                <b-card :header="$t($route.name)" class="mt-3">
                    <el-table class="custom-table" :data="ajaxTable" @expand-change="expandChange" @row-click="expandRow" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width">
                            <template slot="header">
                                <p>{{title.label}}</p>
                                <b-form-input :placeholder="title.label" @keyup.enter="initialize()" v-model="ajaxSearch[title.prop]"></b-form-input>
                            </template>
                        </el-table-column>
                        <el-table-column type="expand">
                            <b-button variant="info" size="lg" v-b-modal.infoVerify>{{$t('button.check')}}</b-button>
                        </el-table-column>
                    </el-table>
                    <b-row class="mt-3">
                        <b-col sm="12" md="3" class="pr-0">
                            <span class="float-left">{{$t('admin.table_show_result',{result:ajaxTool.total_number})}}</span>
                        </b-col>
                        <b-col sm="12" md="9" class="pl-0">
                            <el-pagination class="text-right" layout="sizes,prev, pager, next" @size-change="paginationSizeChange" @current-change="paginationCurrentChange" :current-page.sync="ajaxTool.current_pagination" :total="ajaxTool.total_number" :hide-on-single-page="1" :page-sizes="[10, 30, 50, 100]" :page-size="10" background></el-pagination>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
        <b-modal id="infoVerify" :title="$t('button.check')" hide-footer size="lg">
            <span v-html="ajaxInfo"></span>
        </b-modal>
    </div>
</template>

<script>
import {verifyAjaxTable} from '@/system/model/report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader','reload'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxTool:[],
            ajaxRow:'',     
            ajaxSearch:{limit:'',pagination:'',id:'',created_at:'',remark:'',login:'',status:'',type:''},
            searchType:'',
            ajaxInfo:'',
            titles:[{
                prop: "id",
                label: this.$t('admin.table_id'),
                width:'70'
            },{
                prop: "created_at",
                label: this.$t('admin.table_date'),
                width:'140'
            },{
                prop: "login",
                label: this.$t('admin.table_username'),
                width:'169'                
            },{
                prop: "remark",
                label: this.$t('admin.table_remark'),
                width:'169'
            },{
                prop: "status",
                label: this.$t('admin.table_status'),
                width:'169'                
            }] 
        }
    },methods:{
        initialize(){
            var self = this;
            var result = verifyAjaxTable(this.ajaxSearch.limit,this.ajaxSearch.pagination,this.ajaxSearch.id,this.ajaxSearch.created_at,this.ajaxSearch.remark,this.ajaxSearch.login,this.ajaxSearch.status,this.ajaxSearch.type);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.datatable.data;
                    self.ajaxTool = value.data.datatable;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },expandRow(row){
            this.$refs.tableTest.toggleRowExpansion(row);
            this.ajaxRow = row.id
            this.ajaxUrl = row.url;
            this.showEdit = false;
            this.ajaxInfo = row.content;
            if(row.status == 1){
                this.showEdit = true;
            }
        },expandChange(row,expandedRows){
            if(expandedRows.length>1){
                expandedRows.shift()
            }
        },paginationSizeChange(limit){
            this.ajaxSearch.limit = limit;
            this.initialize();
        },paginationCurrentChange(pagination){
            this.ajaxSearch.pagination = pagination;
            this.initialize();
        }
    },created(){
        this.preloader(false);
        this.initialize();
    }
}
</script>
